import styled from "styled-components";

export const StyledStateMessage = styled.p`
  font-family: "Noto Sans Hebrew", sans-serif;
  font-size: 14px;
  color: #7e8aad;
  text-align: center;
  padding: 32px 16px;

  &.error {
    color: #c0392b;
  }
`;
